import { AddressAutofill } from "@mapbox/search-js-react";
import { Flex, Grid, Text, TextField } from "@radix-ui/themes";
import { FieldErrors } from "react-hook-form";

import { ShippingDetails } from "../../../api/public";

export const AddressInput = ({
  value,
  onChange,
  errors,
}: {
  value?: ShippingDetails;
  onChange?: (value?: Partial<ShippingDetails>) => void;
  errors?: FieldErrors<ShippingDetails>;
}) => {
  return (
    <form>
      {/* form is needed for autocomplete to work */}
      <AddressAutofill accessToken={process.env.REACT_APP_MAPBOX_KEY ?? ""}>
        <Flex direction="column" gap="2">
          <Flex direction="column" gap="1">
            <TextField.Root
              type="text"
              autoComplete="address-line1"
              placeholder="Address"
              color={errors?.address_line_1 && "red"}
              value={value?.address_line_1}
              onChange={(e) => {
                onChange?.({
                  ...value,
                  address_line_1: e.target.value,
                });
              }}
            />
            {errors?.address_line_1 && (
              <Text size="1" color="red">
                {errors.address_line_1.message}
              </Text>
            )}
          </Flex>
          <TextField.Root
            type="text"
            autoComplete="address-line2"
            placeholder="Address ext."
            value={value?.address_line_2}
            onChange={(e) => {
              onChange?.({
                ...value,
                address_line_2: e.target.value,
              });
            }}
          />
          <Flex gap="1" direction="column">
            <TextField.Root
              type="text"
              autoComplete="address-level2"
              placeholder="City"
              value={value?.city}
              onChange={(e) => {
                onChange?.({
                  ...value,
                  city: e.target.value,
                });
              }}
            />
            {errors?.city && (
              <Text size="1" color="red">
                {errors.city.message}
              </Text>
            )}
          </Flex>
          <Grid gap="2" columns="2">
            <Flex gap="1" direction="column">
              <TextField.Root
                type="text"
                autoComplete="address-level1"
                placeholder="State/Province/Region"
                value={value?.state}
                onChange={(e) => {
                  onChange?.({
                    ...value,
                    state: e.target.value,
                  });
                }}
              />
              {errors?.state && (
                <Text size="1" color="red">
                  {errors.state.message}
                </Text>
              )}
            </Flex>
            <Flex gap="1" direction="column">
              <TextField.Root
                type="text"
                autoComplete="postal-code"
                placeholder="ZIP or Postal Code"
                value={value?.zip}
                onChange={(e) => {
                  onChange?.({
                    ...value,
                    zip: e.target.value,
                  });
                }}
              />
              {errors?.zip && (
                <Text size="1" color="red">
                  {errors.zip.message}
                </Text>
              )}
            </Flex>
          </Grid>
          <Flex gap="1" direction="column">
            <TextField.Root
              type="text"
              autoComplete="country-name"
              placeholder="Country"
              value={value?.country}
              onChange={(e) => {
                onChange?.({
                  ...value,
                  country: e.target.value,
                });
              }}
            />
            {errors?.country && (
              <Text size="1" color="red">
                {errors.country.message}
              </Text>
            )}
          </Flex>
        </Flex>
      </AddressAutofill>
    </form>
  );
};
